module.exports = __webpack_public_path__ + "img/farzana-christopher-57.638537a2.jpg";